import React from 'react';
import * as S from './style'
import { UserProfileMenuProps } from './type';

import MenuBookIcon from '@mui/icons-material/MenuBook';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import { useLanguage } from '../../contexts/LanguageContext';

const UserProfileMenu: React.FC<UserProfileMenuProps> = ({
  anchorEl,
  open,
  onClose,
  userRole,
  onProfile,
  onSettings,
  onGuidelines,
  onAdmin,
  onLogout,
}) => {
  const { t } = useLanguage();

  const adminItems: React.ReactNode[] = userRole === 'superuser'
    ? [
        <MenuItem key="admin-header" disabled>
          <S.StyledTypography variant="body2" color="text.secondary">
            {t('profile.admin')}
          </S.StyledTypography>
        </MenuItem>,
        <MenuItem key="admin-link" onClick={onAdmin}>
          <ListItemIcon>
            <AdminPanelSettingsIcon fontSize="small" />
          </ListItemIcon>
          <S.AdminContainer>
            <S.StyledTypography variant="body2" sx={{ flex: 1, minWidth: 0 }}>{t('top.adminPanel')}</S.StyledTypography>
            <OpenInNewIcon fontSize="small" sx={{ ml: 1, color: 'text.secondary', flexShrink: 0 }} />
          </S.AdminContainer>
        </MenuItem>,
        <Divider key="admin-divider" sx={{ my: 0.5 }} />,
      ]
    : [];

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 200,
          maxWidth: 320,
          boxShadow: '0 12px 24px rgba(0,0,0,0.12)',
        },
      }}
    >
      <MenuItem disabled>
        <S.StyledTypography variant="body2" color="text.secondary">
          {t('profile.account')}
        </S.StyledTypography>
      </MenuItem>
      <MenuItem onClick={onProfile}>
        <ListItemIcon>
          <PersonOutlineIcon fontSize="small" />
        </ListItemIcon>
        <S.StyledTypography variant="body2">{t('top.myProfile')}</S.StyledTypography>
      </MenuItem>
      <MenuItem onClick={onSettings}>
        <ListItemIcon>
          <SettingsOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <S.StyledTypography variant="body2">{t('top.settings')}</S.StyledTypography>
      </MenuItem>
      <MenuItem onClick={onGuidelines}>
        <ListItemIcon>
          <MenuBookIcon fontSize="small" />
        </ListItemIcon>
        <S.StyledTypography variant="body2">{t('nav.guidelines')}</S.StyledTypography>
      </MenuItem>
      <Divider sx={{ my: 0.5 }} />
      {adminItems}
      <MenuItem onClick={onLogout}>
        <ListItemIcon>
          <LogoutOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <S.StyledTypography variant="body2">{t('top.logout')}</S.StyledTypography>
      </MenuItem>
    </Menu>
  );
};

export default UserProfileMenu;
